module.exports = __webpack_public_path__ + "static/drag_and_drop_email@3x.74cdd110.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/drag_and_drop_email@3x.png
// module id = 217
// module chunks = 193162123475590 216210090109534